var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.75H21.75V9C21.75 6.381 19.619 4.25 17 4.25H7C4.381 4.25 2.25 6.381 2.25 9V10.75H3C3.689 10.75 4.25 11.311 4.25 12C4.25 12.689 3.689 13.25 3 13.25H2.25V15C2.25 17.619 4.381 19.75 7 19.75H17C19.619 19.75 21.75 17.619 21.75 15V13.25H21C20.311 13.25 19.75 12.689 19.75 12C19.75 11.311 20.311 10.75 21 10.75ZM20.25 14.646V15C20.25 16.792 18.792 18.25 17 18.25H15.75V16C15.75 15.586 15.414 15.25 15 15.25C14.586 15.25 14.25 15.586 14.25 16V18.25H7C5.208 18.25 3.75 16.792 3.75 15V14.646C4.903 14.319 5.75 13.256 5.75 12C5.75 10.744 4.903 9.681 3.75 9.354V9C3.75 7.208 5.208 5.75 7 5.75H14.25V8C14.25 8.414 14.586 8.75 15 8.75C15.414 8.75 15.75 8.414 15.75 8V5.75H17C18.792 5.75 20.25 7.208 20.25 9V9.354C19.097 9.681 18.25 10.744 18.25 12C18.25 13.256 19.097 14.319 20.25 14.646ZM15.75 11V13C15.75 13.414 15.414 13.75 15 13.75C14.586 13.75 14.25 13.414 14.25 13V11C14.25 10.586 14.586 10.25 15 10.25C15.414 10.25 15.75 10.586 15.75 11Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.a401657a.svg";
export { ForwardRef as ReactComponent };